export const INVENTORY_UNIT_OPTIONS = [
    { value: 'UN', label: 'Unidade (UN)' },
    { value: 'ML', label: 'Mililitro (ML)' },
    { value: 'L', label: 'Litro (L)' },
    { value: 'G', label: 'Grama (G)' },
    { value: 'KG', label: 'Quilograma (KG)' },
    { value: 'PCT', label: 'Pacote (PCT)' },
    { value: 'CX', label: 'Caixa (CX)' },
] as const;

export const INVENTORY_UNIT_VALUES = INVENTORY_UNIT_OPTIONS.map((option) => option.value);

export const ITEM_TYPE_LABELS: Record<string, string> = {
    CONSUMIVEL: 'Consumível',
    REVENDA: 'Revenda',
};

export const MOVEMENT_TYPE_LABELS: Record<string, string> = {
    ENTRADA: 'Entrada',
    SAIDA: 'Saída',
    AJUSTE: 'Ajuste',
    PERDA: 'Perda',
};

export const MOVEMENT_WARNING_LABELS: Record<string, string> = {
    AJUSTE_SEM_DIRECAO: 'Ajuste registrado sem direção.',
    AJUSTE_SEM_MOTIVO: 'Ajuste registrado sem motivo.',
    MOTIVO_AUTOMATICO: 'O motivo foi preenchido automaticamente.',
};

export const formatQuantity = (value: unknown) =>
    (Number(value) || 0).toLocaleString('pt-BR', { maximumFractionDigits: 3 });

export const isLowStock = (item: any) => {
    const onHand = item?.balance?.onHand ?? 0;

    return (
        (item?.minStock !== undefined && item?.minStock !== null && onHand <= item.minStock) ||
        (item?.reorderPointManual !== undefined && item?.reorderPointManual !== null && onHand <= item.reorderPointManual)
    );
};
